<template>
    <section class="section work-area ptb_100">
        <!-- Work Slider Wrapper -->
        <div class="work-wrapper d-none d-md-block">
            <div class="work-slider-wrapper" data-aos="zoom-in">
                <!-- Work Slider -->
                <ul class="work-slider owl-carousel">
                    <li class="slide-item">
                        <img src="assets/img/DarkModeFlashcardScreenshot copy.png" alt="">
                    </li>
                    <li class="slide-item">
                        <img src="assets/img/DarkModePDFSearchScreenshot copy.png" alt="">
                    </li>
                    <li class="slide-item">
                        <img src="assets/img/DarkModeClipsScreenshot copy.png" alt="">
                    </li>
                    <li class="slide-item">
                        <img src="assets/img/DarkModeQuizScreenshot copy.png" alt="">
                    </li>
                </ul>
            </div>
        </div>
        <div class="container">
            <!-- Work Content -->
            <div class="row justify-content-end justify-content-lg-between work-content" id="work-slider-pager">
                <div class="col-12 col-sm-6">
                    <a href="#" class="pager-item active">
                        <!-- Single Work -->
                        <div class="single-work d-inline-block text-center p-4">
                            <h3 class="mb-2">Study</h3>
                            <p>Easily improve rules recall and expand your vocabulary with 'Flashcards'</p>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-sm-6">
                    <a href="#" class="pager-item">
                        <!-- Single Work -->
                        <div class="single-work d-inline-block text-center p-4">
                            <h3 class="mb-2">Read</h3>
                            <p>Search through the basketball rules 'PDF' for keywords and learn more</p>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-sm-6">
                    <a href="#" class="pager-item">
                        <!-- Single Work -->
                        <div class="single-work d-inline-block text-center p-4">
                            <h3 class="mb-2">Watch</h3>
                            <p>Get instructional training tips and proper Mechanics with 'Officiating Clips'</p>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-sm-6">
                    <a href="#" class="pager-item">
                        <!-- Single Work -->
                        <div class="single-work d-inline-block text-center p-4">
                            <h3 class="mb-2">Test</h3>
                            <p>Challenge yourself with 'Quiz' mode. Can you get a perfect score?</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>